import {
  ASSET_SELECTED,
  MAP_ASSET_SELECTED,
  ASSETS_FETCH_START,
  ASSETS_FETCH_SUCCESS,
  ASSETS_FETCH_FAIL,
  ASSETS_TRACK_LATEST_SEARCH,
  UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER,
  TRIGGERED_MOUSE_EVENT_FLAG,
  ADGLARE_CONTENT_FETCHED,
} from '../constants/actionTypes.js'

const initialState = {
  initialized: false,
  currentSearchId: null,
  list: [],
  fetchProgress: {
    loading: true,
    errors: null,
  },
  offset: 0,
  selectedId: 0,
  mapSelectedId: 0,
  triggeredMouseEventFlag: false,
  total: 0,
  adglareContent: null,
  adglareFetchAttempted: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * Fetch Assets
     */
    case ASSETS_FETCH_START: {
      return Object.assign({}, state, {
        fetchProgress: {
          loading: true,
          errors: null,
        },
      })
    }
    case ASSETS_FETCH_FAIL: {
      if (action.error.currentSearchId !== state.currentSearchId) {
        return state
      }

      return Object.assign({}, state, {
        currentSearchId: null,
        fetchProgress: {
          loading: false,
          errors: action.error.message,
        },
      })
    }
    case ASSETS_FETCH_SUCCESS: {
      if (action.value.currentSearchId !== state.currentSearchId) {
        return state
      }

      return Object.assign({}, state, {
        // Setting this means that if any long-running searches are trying to resolve the check above will prevent them
        // from overwriting the current results
        currentSearchId: action.value.currentSearchId,
        fetchProgress: {
          loading: false,
          errors: null,
        },
        list: action.value.assets,
        initialized: true,
        nearbyTotal: action.value.nearbyTotal,
        total: action.value.total,
        offset: action.value.offset,
        propertyTypeTotals: action.value.propertyTypeTotals,
        remoteBideTotals: action.value.remoteBideTotals,
      })
    }

    /**
     * Select Asset
     */
    case ASSET_SELECTED: {
      return Object.assign({}, state, { selectedId: action.value })
    }

    /**
     * Select Asset on the Map
     */
    case MAP_ASSET_SELECTED: {
      return Object.assign({}, state, { mapSelectedId: action.value })
    }

    case TRIGGERED_MOUSE_EVENT_FLAG: {
      return Object.assign({}, state, { triggeredMouseEventFlag: action.value })
    }

    case 'UPDATE_PROPERTY_SAVE_STATE': {
      const list = state.list.slice()

      const index = list.findIndex(
        listing => listing.primary_property.property_id === action.property_id
      )

      if (index > -1) {
        list[index].primary_property.is_currently_saved = action.isSaved
      }

      return { ...state, list }
    }

    case UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER: {
      const savedPropertyIds = new Set(action.currently_saved_property_ids)

      const list = state.list.map(listing => {
        const propertyId = listing.primary_property.property_id

        return savedPropertyIds.has(propertyId)
          ? {
              ...listing,
              primary_property: {
                ...listing.primary_property,
                is_currently_saved: true,
              },
            }
          : listing
      })

      return { ...state, list }
    }

    case ASSETS_TRACK_LATEST_SEARCH: {
      return Object.assign({}, state, {
        currentSearchId: action.currentSearchId,
      })
    }

    case ADGLARE_CONTENT_FETCHED: {
      return Object.assign({}, state, {
        adglareContent: action.value,
        adglareFetchAttempted: true,
      })
    }

    default:
      return state
  }
}

export default reducer
export { initialState }
